$(function () {
    if ($('#cart-details').length) {
        // Load store locations configuration
        var storeLocationsConfigText = $('#storeLocationsConfig').text();
        var storeLocationsConfig = storeLocationsConfigText ? JSON.parse(storeLocationsConfigText) : { useStoreLocations: false, storeLocations: [] };

        new Vue({
            store: store,
            el: '#cart-details',
            data: {
                cart: null,
                ready: false,
                editItem: null,
                removeItem: null,
                editError: null,
                removeError: null,
                quoteError: null,
                quoteSent: null,
                showQuoteModal: false,
                useStoreLocations: storeLocationsConfig.useStoreLocations,
                storeLocations: storeLocationsConfig.storeLocations,
                selectedLocationAddress: null,
                quoteForm: {
                    isPersonal: false,
                    storeLocationId: null,
                    shippingAddress: '',
                    shippingAddress2: '',
                    shippingCity: '',
                    shippingStateProvince: '',
                    shippingPostalCode: '',
                    shippingCountryCode: 'US'
                }
            },
            computed: {
                canUpdate: function () {
                    return ['', null, undefined].indexOf(this.editItem.quantity) === -1 && !isNaN(this.editItem.quantity) && this.editItem.quantity >= 0
                }
            },
            watch: {
                'quoteForm.isPersonal': function (newVal) {
                    // Clear store location when switching to personal shipping
                    if (newVal === true) {
                        this.quoteForm.storeLocationId = null;
                        this.selectedLocationAddress = null;
                    }
                }
            },
            methods: {
                checkout: function () {
                    window.location.href = '/checkout';
                },
                formatPrice: function (price) {
                    if (price) {
                        var formatter = new Intl.NumberFormat('en-US', {
                            style: 'currency',
                            currency: 'USD',
                        });

                        return formatter.format(price);
                    }
                    return '--';
                },
                clone: function (obj) {
                    if (!obj) {
                        return obj;
                    }
                    return JSON.parse(JSON.stringify(obj));
                },
                confirmEditItem: function () {
                    var vm = this;
                    vm.editError = null;
                    axios.put('/api/cart/update', this.editItem).then(function (resp) {
                        if (resp && resp.data) {
                            vm.cart = resp.data;
                        }
                        vm.$store.dispatch('updateCartSummary');
                        vm.editItem = null;
                    }).catch(function (error) {
                        vm.editError = error.response.data.error;
                    })
                },
                confirmRemoveItem: function () {
                    var vm = this;
                    vm.removeError = null;
                    axios.delete('/api/cart/remove', { data: { id: this.removeItem.id } }).then(function (resp) {
                        if (resp && resp.data) {
                            vm.cart = resp.data;
                        }
                        vm.$store.dispatch('updateCartSummary');
                        vm.removeItem = null;
                    }).catch(function (error) {
                        vm.removeError = error.response.data.error;
                    })
                },
                onLocationSelected: function () {
                    var vm = this;
                    vm.selectedLocationAddress = null;

                    if (vm.quoteForm.storeLocationId) {
                        var locationId = parseInt(vm.quoteForm.storeLocationId);
                        var selectedLocation = vm.storeLocations.find(function (loc) { return loc.id === locationId; });

                        if (selectedLocation) {
                            var addressLines = [];
                            addressLines.push(selectedLocation.address);
                            if (selectedLocation.address2) {
                                addressLines.push(selectedLocation.address2);
                            }
                            addressLines.push(selectedLocation.city + ', ' + selectedLocation.stateProvince + ' ' + selectedLocation.postalCode);
                            if (selectedLocation.countryCode && selectedLocation.countryCode !== 'US') {
                                addressLines.push(selectedLocation.countryCode);
                            }

                            vm.selectedLocationAddress = addressLines.join('<br />');
                        }
                    }
                },
                submitQuoteRequest: function () {
                    var vm = this;
                    vm.quoteError = null;

                    // Submit quote request with store location or shipping address
                    axios.post('/api/cart/quote', vm.quoteForm).then(function (resp) {
                        if (resp && resp.data) {
                            vm.showQuoteModal = false;
                            vm.quoteSent = true;
                            // Reset form
                            vm.quoteForm = {
                                isPersonal: false,
                                storeLocationId: null,
                                shippingAddress: '',
                                shippingAddress2: '',
                                shippingCity: '',
                                shippingStateProvince: '',
                                shippingPostalCode: '',
                                shippingCountryCode: 'US'
                            };
                            vm.selectedLocationAddress = null;
                        }
                        vm.quoteError = null;
                    }).catch(function (error) {
                        vm.quoteError = error.response && error.response.data && error.response.data.error
                            ? error.response.data.error
                            : 'An error occurred while submitting your quote request.';
                    });
                }
            },
            mounted: function () {
                var cartJson = $('#cartJson').text();
                this.cart = JSON.parse(cartJson);
            }
        });
    }
});